export enum HighlightBlock {
  Root = 'Highlight',
}
